// extracted by mini-css-extract-plugin
module.exports = {"color-title":"colorInput_color-title__3PzQn","color-viewer":"colorInput_color-viewer__3XNb2"};